import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { FormControl, FormGroup } from '@angular/forms';

declare var require: any;
import * as _ from 'lodash-es';

@Component({
  selector: 'app-learning-center',
  templateUrl: './learning-center.component.html',
  styleUrls: ['./learning-center.component.scss']
})
export class LearningCenterComponent implements OnInit {

  workers:any;
  monitors:any;

  send_worker_info = "";
  send_monitor_info = "";

  tab = "workers";

  loading = false;

  groups_filter:any = [];
  groups_filter_names:any = [];

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {



    this.getSummary();

  }

  getSummary(){

    let filter:any = {}

    if(this.groups_filter.length > 0){
      filter.groups = this.groups_filter.join(",");
    }

    //console.log('filter', filter);

    this.okService.get("learn/summary",filter)
    .subscribe((data:any) => {

      this.workers = data.body['workers'];
      this.monitors = data.body['monitors'];

      //console.log(this.workers);

    });

  }

  sendMonitorLinks(){

    let filter:any = {}

    if(this.groups_filter.length > 0){
      filter.groups = this.groups_filter.join(",");
    }

    this.loading = true;

    //console.log('filter', filter);

    this.okService.post("learn/sendmonitors",filter)
    .subscribe((data:any) => {

      //console.log(data.body);

      this.loading = false;

      if(data.body['message']){
        this.send_monitor_info = data.body['message'];
      }

      this.getSummary();

    });

  }

  sendWorkerLinks(){

    let filter:any = {};

    if(this.groups_filter.length > 0){
      filter.groups = this.groups_filter.join(",");
    }

    this.loading = true;

    //console.log('filter', filter);

    this.okService.post("learn/sendworkers",filter)
    .subscribe((data:any) => {

      //console.log(data.body);

      this.loading = false;

      if(data.body['message']){
        this.send_worker_info = data.body['message'];
      }

      this.getSummary();

    });
  }

  sendWorkerLink(worker:any){
    this.okService.post("learn/sendworker/"+worker.id,{})
    .subscribe((data:any) => {

      //console.log(data.body);

      if(data.body['message']){
        this.send_worker_info = data.body['message'];
      }

      this.getSummary();

    });
  }

  sendMonitorLink(monitor:any){
    this.okService.post("learn/sendmonitor/"+monitor.id,{})
    .subscribe((data:any) => {

      //console.log(data.body);

      if(data.body['message']){
        this.send_worker_info = data.body['message'];
      }

      this.getSummary();

    });
    
  }


  groupFilter(){

    this.groups_filter_names = [];

    let _this = this;

    _.forEach(this.groups_filter, function(group_id:any) {
      
      let group = _.find(_this.okService.groups, function(group:any) { return group.id == group_id; });
      if(group){
        _this.groups_filter_names.push(group.name);
      }
      
    });

    //console.log(this.groups_filter_names);

    this.getSummary();
  }

}
